import { createAction, props } from '@ngrx/store';
export const setTalkingPointToEdit = createAction('[Talking Points List Page] Set Talking Point to Edit', props());
